import React from 'react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

import './css/LoaderFabric.css';

const LoaderFabric = props => {
    const styled = props.overlay ? {
        background: 'rgba(222,222,222, .5)',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        zIndex: 1000001
    } : null;

    return (
        <div className="Spinner" style={styled} >
            <Spinner size={SpinnerSize.large} label="Loading..." ariaLive="assertive" labelPosition="top" />
        </div>
    );
}

export default LoaderFabric;